<template>
    <div class="clientes-section">
        <div class="clientes-content">
            <h2 class="clientes-title fuente-posm">Tus Clientes Invierten en Comodidad</h2>
            <p class="clientes-text fuente-nova">
                Por eso no les importa pagar un poco más en plataformas de delivery. El problema es que esas ganancias extra se van en comisiones que pueden llegar hasta el 30% de cada venta.
                <br><br>
                ¿Y si pudieras darles esa misma comodidad y quedarte con el 100% de tus ganancias?
            </p>
        </div>
        <div class="clientes-video">
            <video controls :poster="posterUrl">
                <source :src="videoUrl" type="video/mp4">
            </video>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClientesInviertenNew',
    data() {
        return {
            posterUrl: require('@/assets/images/a18.webp'),
            videoUrl: require('@/assets/images/O.mp4')
        }
    }
}
</script>

<style lang="css" scoped>
.clientes-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 60px;
    background-color: #272727;
}

.clientes-content {
    flex: 1;
    max-width: 600px;
}

.clientes-title {
    color: var(--color-5);
    font-size: 70px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.clientes-text {
    color: var(--color-5);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

.clientes-video {
    flex: 0 0 auto;
    max-width: 500px;
}

.clientes-video video {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .clientes-title {
        font-size: 60px;
    }

    .clientes-text {
        font-size: 27px;
    }

    .clientes-video {
        max-width: 400px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .clientes-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 0;
    }

    .clientes-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .clientes-video {
        order: 2;
        width: 100%;
        max-width: none;
        margin-top: 60px;
        display: flex;
        justify-content: center;
    }

    .clientes-video video {
        width: 90%;
        max-width: none;
    }

    .clientes-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .clientes-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
